import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { eye_view, Search_icon } from "../../assets/img";
import Select from "react-select";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";

const AbsentList = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [openPop, setOpenPop] = useState(false);
  const [reason, setReason] = useState("");
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path] ?? {
      property: "",
      search: "",
      unread_only: false,
    },
  );
  const [optionsList, setOptionsList] = useState({
    property: [],
  });
  const [absentList, setAbsentList] = useState([]);
  useEffect(() => {
    getProperties();
  }, []);
  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, ...selectedFilter },
    }));
  }, [selectedFilter, page, selectedFilter.unread_only]);

  //get properties
  const getProperties = async () => {
    const res = await get(URLS.PROPERTIES_DROPDOWN);
    console.log("properties dropdown", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, property: modifiedList }));
    }
  };

  const getList = async (pageNumber = 1) => {
    const { search, property } = selectedFilter;
    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if (property) {
      payload.append("property_id", property?.value);
    }
    const res = await post(
      `${URLS.ABSENT_LIST}?page=${pageNumber}&unread_only=${selectedFilter?.unread_only}`,
      payload,
    );
    // const res = await post(URLS.ABSENT_LIST + "?page=" + pageNumber, payload);
    console.log("absent List", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setAbsentList(res?.data);
    }
  };

  const handleChangeFilter = (name, val) => {
    setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const handleReason = async (d) => {
    if (!reason) {
      toast.error("Please enter the Reason");
      return;
    }
    let payload = {
      booking_code: d?.booking_code,
      action: d?.type === "Accept" ? "cancel" : "note",
      reason: reason,
    };
    let res = await post(URLS.ABSENT_REASON, payload);
    console.log("reason res", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
      setOpenPop(false);
      setReason("");
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                // flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              {row?.original?.has_unread_notification &&
                checkPermission("CAN-EDIT-ABSENT_LIST") && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                    style={{ width: 20, height: 20, marginTop: 9 }}
                  />
                )}
              {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )}
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
            </div>
          );
          // const pageSize = 10;
          // return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Property Name",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div className="center text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Date",
        accessor: "from_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Cancelled By",
        accessor: "cancelled_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-1">
              <button
                onClick={() => {
                  setOpenPop({
                    type: "Accept",
                    booking_code: row.original?.booking_code,
                  });
                }}
                className={`${"active-btn"} p-2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
              >
                Accept
              </button>
              <button
                onClick={() => {
                  let r = row.original.reason;
                  setOpenPop({
                    type: "Reason",
                    booking_code: row.original?.booking_code,
                    reason: r ?? "",
                  });
                  if (r) setReason(r);
                }}
                className={`${"deactive-btn"} p-2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
              >
                Reason
              </button>
              {/* )} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-EDIT-ABSENT_LIST") ? [...d, action] : d;
  }, [page, selectedOwners]);
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };
  return (
    <div>
      <Topbar header={"Notification"} />
      <div
        className="d-flex mb-4"
        style={{
          flexDirection: "row",
          // justifyContent: "space-between",
          alignItems: "center",
          gap: 50,
          width: "100%",
        }}
      >
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        <div className="d-flex" style={{ alignItems: "center" }}>
          <input
            type="checkbox"
            checked={selectedFilter?.unread_only}
            onChange={() =>
              handleChangeFilter("unread_only", !selectedFilter?.unread_only)
            }
          />{" "}
          <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
            Check New Notification
          </p>
          {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
        </div>
      </div>
      {/* <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2> */}
      <div className="d-flex ac-je mt-3 gap-3 flex-wrap">
        <Select
          className="location-search"
          options={optionsList?.property}
          isClearable
          onChange={(e) => {
            handleChangeFilter("property", e);
          }}
          value={selectedFilter?.property}
          placeholder={"property"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={absentList}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />

      {openPop && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setOpenPop(false);
                  setReason("");
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p
                  className={`f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20`}
                >
                  {" "}
                  Reason
                </p>
                <textarea
                  className="input-box mt-1 w-100"
                  onChange={(e) => setReason(e.target.value)}
                  value={reason}
                  disabled={
                    openPop.type === "Reason" && Boolean(openPop?.reason)
                  }
                  placeholder="Describe..."
                />
              </div>
            </div>
            {!openPop?.reason && (
              <div className="d-flex ac-jc  mt-5">
                <button
                  onClick={() => {
                    handleReason(openPop);
                  }}
                  className="submit-btn"
                >
                  submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AbsentList;
